export default "__VITE_ASSET__Cj_2211V__"